<template>
    <span>
        <el-button
            type="text"
            @click="visible=true"
        >
            查看示例
        </el-button>
        <el-dialog
            title="查看示例"
            :visible.sync="visible"
            width="350px"
        >
            <div
                v-for="(item, idx) in data"
                :key="idx"
            >
                <div
                    class="text-info"
                >{{ item.desc }}</div>
                <el-carousel
                    v-if="item.pics.length"
                    class="example-pic"
                    :autoplay="false"
                    :arrow="item.pics.length > 1 ? 'always' : 'never'"
                >
                    <el-carousel-item
                        v-for="(pic, i) in item.pics"
                        :key="i"
                    >
                        <xn-upload
                            :value="pic"
                            list-type="picture-card"
                            accept="image/jpeg, image/png, image/jpg"
                            disabled
                            in-dialog
                        />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <span
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="mini"
                    @click="visible = false"
                >我知道了</el-button>
            </span>
        </el-dialog>
    </span>
</template>

<script>
const configMap = {
    // 保质期
    guaranteePeriod: [
        {
            desc: '1. 书写格式与包装保持一致，例：包装上写365天，不能填写成1年，需填写365天',
            pics: ['https://p0.meituan.net/mallimages/6f6e723e2d849d727ad1733c50c273b61128815.jpg'],
        },
        {
            desc: '2. 商品包装上出现多个保质期时，按照最短的日期录入',
            pics: ['https://p0.meituan.net/mallimages/1782a2a49dc17fc8df45a80f94ebb24c428823.jpg'],
        },
        {
            desc: '3. 商品包装上明确保质期如：2021.11.30-2022.11.30，需换算成年录入：1年',
            pics: [],
        },
    ],
    // 生产商
    manufacturer: [
        {
            desc: '1. 当标签上只有一个生产商时，绑定唯一的生产商即可',
            pics: ['https://p0.meituan.net/mallimages/5157a9b03b225285331ca03bc919cd2b405558.png'],
        },
        {
            desc: '2. 当标签上多个生产商时，绑定检测报告上的生产商（标称生产单位、生产单位）',
            pics: ['https://p1.meituan.net/mallimages/4aa9cb1faaab40fcee05031e396531e9298330.jpg'],
        },
    ],
    // 实物图
    realPic: [
        {
            desc: '1. 请上传商品标签全部可视面的照片,并且标签上的文字清晰可见',
            pics: ['https://p0.meituan.net/mallimages/cae35d4082952ac038cbffd165fa33e66173396.jpg'],
        },
        {
            desc: '2. 必须上传该提报商品的实物标签照片',
            pics: ['https://p0.meituan.net/mallimages/4b2d9f8ba6ffaac8afd72d0bd13df1cd785493.jpg'],
        },
        {
            desc: '3. 符合法律、法规、食品安全标准，例如：《商标法》规定商品标签不得标示“驰名商标”',
            pics: ['https://p0.meituan.net/mallimages/45d74d69987d422ae7c730992efa9f11181522.png'],
        },
        {
            desc: '4. 需上传最新包装照片，例如：QS标志已过时，不可上传',
            pics: ['https://p0.meituan.net/mallimages/0383580b922cfca984e3d06ca55d92cd470048.png'],
        },
    ],
    // 检测报告
    checkReport: [
        {
            desc: '1. 第三方检测报告由签发日期开始计算：食品类有效期 1 年、非食类有效期 3 年 ；快检报告由签发日期开始计算：果蔬、鲜活水产类有效期 1 个月',
            pics: ['https://p0.meituan.net/mallimages/871c3328ccf2651ee6cf338ca293e345719678.jpg', 'https://p0.meituan.net/mallimages/0a31a07f8fceded2bb5efd48190e8b27890086.png'],
        },
        {
            desc: '2. 商品检测报告需包含CMA章',
            pics: ['https://p0.meituan.net/mallimages/2b9898bc23198272827b53458465c323168081.png'],
        },
        {
            desc: '3. 所售商品与检测报告上的商品名称一致',
            pics: ['https://p0.meituan.net/mallimages/450a253ffa1f3f24e4df26c61b6743b6541406.jpg'],
        },
        {
            desc: '4. 报告要完整，必须包含封面页, 不能少页',
            pics: ['https://p0.meituan.net/mallimages/3c85aa457bd98b5bf4f469475df1142c471083.jpg'],
        },
    ],
    // 报关单/入境检测证明
    baoguandan: [
        {
            desc: '1. 报关单从进口日期开始计算, 截止日期食品+1 年，非食+3年；卫检从签发日期开始计算，截止日期食品+1 年，非食+3年',
            pics: ['https://p0.meituan.net/mallimages/6d34551c7aea9ef7e40e7b70f7ae5a3f816791.jpg'],
        },
        {
            desc: '2. 保证报关单、卫检的合同号或提运单号一致',
            pics: ['https://p0.meituan.net/mallimages/344f41f1854551bd0721f9971479d4e4816087.jpg'],
        },
        {
            desc: '3. 报关单、卫检的合同号或提运单不能被打码',
            pics: ['https://p0.meituan.net/mallimages/7dc4c73cc25e2b36075ef0e84cc2d718832755.jpg'],
        },
        {
            desc: '4. 报关单明细中需包含该在售商品，如商品为组合商品，则报关单中需要包含组合商品中的全部商品',
            pics: ['https://p0.meituan.net/mallimages/8037ef796e072923d3a703d815b1ad601071112.jpg'],
        },
    ],
    // 副标题
    subTitle: [
        {
            desc: `1. 副标题要求
                    ①8-10字为宜
                    ②语句通顺，不能出现错别字
                    ③可以使用商品营销语言、客诉点说明、竞争优势、局部特点等
                    ④不能使用广告违禁词
                    ⑤不能和主标题信息重复`,
            pics: [],
        },
        {
            desc: '2. C端展示示例',
            pics: ['https://p0.meituan.net/mallimages/e6da4df3418226eec7aa2df4524e1e66126915.png'],
        },
    ],
    // 商品卖点
    sellingPoints: [
        {
            desc: `1. 商品卖点要求
                    ①每个SKU商品卖点必填2个，最多填写6个
                    ②每个卖点文字个数介于2-6之间，最优4个
                    ③需符合广告法
                    ④需与贴合商品本身，严禁与实物不符
                    ⑤涉及资质类卖点需有相应资质文件`,
            pics: [],
        },
        {
            desc: '2. C端展示示例',
            pics: ['https://p0.meituan.net/mallimages/36a3c71e14066f115770eea311e5ffb9585694.jpg'],
        },
    ],
    // 列表用图
    lbPictures: [
        {
            desc: `1. 列表图要求
                    ①图片无任何水印
                    ②需与主图第一张一致
                    ③内容清晰不能模糊`,
            pics: [],
        },
        {
            desc: '2. C端展示示例',
            pics: ['https://p1.meituan.net/mallimages/f769f8dadb777f8cf86aaa47f5a1f36f84151.png'],
        },
    ],
    // 商品主图
    skuPictureList: [
        {
            desc: `通用要求
                    ①所有品类：主图数量不少于5张，不能出现重复图；
                    ②主图不可展示商品生产日期，如有生产日期需做模糊处理；
                    ③不能出现任何水印；
                    ④图片涉及名人头像等法律问题时，需要有相应授权文件`,
            pics: [],
        },
        {
            desc: '1.主图第一张与列表图保持一致，需为白底图。',
            pics: ['https://p1.meituan.net/mallimages/93b91340264a008ce5d8766e5a165542623972.jpg'],
        },
        {
            desc: '2. 主图第2～3帧：用于展示商品场景图。',
            pics: ['https://p0.meituan.net/mallimages/1f654adb93401f4975ca10fae213e07a737025.jpg'],
        },
        {
            desc: '3. 主图第4帧：类标品需展示商品局部背标图，包含清晰的【配料表/营养成分表】等必要信息（注意：信息需与实物包装上一致）；部分生鲜如不涉及配料和营养成分的此图可用于展示场景图。',
            pics: ['https://p0.meituan.net/mallimages/9599df7b83be5922245dd201a965ffe3440153.jpg'],
        },
        {
            desc: '4. 主图第5帧：可灵活用于展示商品外包装/购前提示等（鲜花到手状态/温馨提示/随机发货/新老包装交替等。部分生鲜品可展示温馨提示/客诉说明等）。',
            pics: ['https://p0.meituan.net/mallimages/b63f8eadbb3dba0d495e3eb5cdefae66656791.jpg'],
        },
    ],
    // 商品详情
    description: [
        {
            desc: '1. 涉及商品保质期、规格、储存条件等需要与包装一致',
            pics: ['https://p1.meituan.net/mallimages/b7aea506dcdb8cd46d233ddb4dd96e3f130348.png'],
        },
        {
            desc: '2. 涉及名人肖像使用，资质认证宣传等需有对应授权',
            pics: ['https://p0.meituan.net/mallimages/8ccb5ea3a321ebcb5c77062fa989b11584492.jpg'],
        },
    ],
};

export default {
    name: 'ExamplePicDialog',
    props: {
        type: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            visible: false,
        };
    },
    computed: {
        data() {
            return configMap[this.type];
        },
    },
};
</script>

<style lang="scss" scoped>
/deep/ .example-pic {
    .xx-upload.is-disabled .el-upload--picture-card {
        display: none;
    }
    .el-upload-list--picture-card .el-upload-list__item {
        width: 100%;
        height: 100%;
    }
}
.text-info {
    line-height: 1.4;
    text-align: left !important;
    white-space: normal;
    font: 14px sans-serif;
}
</style>
